import { useState, type ReactNode } from 'react';

/**
 * A section that is closed until asked for. Everything behind the Detail toggle
 * uses this, so the default view stays the decision and its evidence.
 */
export function Collapsible({
  title,
  sub,
  defaultOpen = false,
  children,
}: {
  title: string;
  sub?: string;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className="panel">
      <header
        className="panel__head panel__head--clickable"
        onClick={() => setOpen(!open)}
        role="button"
        tabIndex={0}
        aria-expanded={open}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setOpen(!open);
          }
        }}
      >
        <div style={{ display: 'flex', gap: 10, alignItems: 'baseline', minWidth: 0 }}>
          <span className="faint">{open ? '▾' : '▸'}</span>
          <div style={{ minWidth: 0 }}>
            <h2>{title}</h2>
            {sub ? <p>{sub}</p> : null}
          </div>
        </div>
      </header>
      {/* Unmounted when closed, so collapsed detail costs nothing to render. */}
      {open ? children : null}
    </section>
  );
}
